export default {
  formId: "user-settings-form",
  formFields: {
    username: {
      name: "username",
      label: "Name",
      initialValue: "",
    },
    email: {
      name: "email",
      label: "Email",
      initialValue: "",
    },
    userImage: {
      name: "userImage",
      label: "User image",
      initialValue: "",
    },
    imageUpdated: {
      name: "imageUpdated",
      label: "",
      initialValue: false,
    },
    removeImage: {
      name: "removeImage",
      label: "",
      initialValue: false,
    },
    discord: {
      label: "Discord",
      name: "discord",
      placeholder: "Discord username here",
      initialValue: "",
    },
    twitter: {
      label: "Twitter",
      name: "twitter",
      placeholder: "Twitter username here",
      initialValue: "",
    },
    telegram: {
      label: "Telegram",
      name: "telegram",
      placeholder: "Telegram username here",
      initialValue: "",
    },
    linkedin: {
      label: "Linkedin",
      name: "linkedin",
      placeholder: "Linkedin link here",
      initialValue: "",
    },
    reddit: {
      label: "Reddit",
      name: "reddit",
      placeholder: "Reddit link here",
      initialValue: "",
    },
    instagram: {
      label: "Instagram",
      name: "instagram",
      placeholder: "Instagram username here",
      initialValue: "",
    },
    tiktok: {
      label: "Tiktok",
      name: "tiktok",
      placeholder: "Tiktok username here",
      initialValue: "",
    },
    country: {
      label: "Country",
      name: "country",
      initialValue: "",
    },
    monkeInterests: {
      label: "What interests you at MonkeVentures",
      name: "monkeInterests",
      initialValue: "",
    },
    personalBackground: {
      name: "personalBackground",
      label: "Brief description of personal background",
      initialValue: "",
    },
    areasOfInterest: {
      name: "areasOfInterest",
      label: "Areas of interest",
      initialValue: "",
    },
    domainOfExpertise: {
      name: "domainOfExpertise",
      label: "Domain of expertise",
      initialValue: "",
    },
    editingWhitelistRequest: {
      name: "editingWhitelistRequest",
      label: "",
      initialValue: true,
    },
    isLedger: {
      name: "isLedger",
      label: "",
      initialValue: false,
    },
  },
};
